// // Save this as 'build-box.js' in your assets folder

// class BuildBox extends HTMLElement {
//   constructor() {
//     super();
//     this.boxSize = parseInt(this.dataset.boxSize);
//     this.selections = []; // Array to allow duplicates
//     this.init();
//   }

//   init() {
//     this.variantItems = this.querySelectorAll('.m-build-box__variant-item');
//     this.progressFill = this.querySelector('.m-build-box__progress-fill');
//     this.progressText = this.querySelector('.m-build-box__progress-text');
//     this.addToCartBtn = this.querySelector('.m-build-box__add-to-cart');
//     this.clearBtn = this.querySelector('.m-build-box__clear');
//     this.priceDisplay = this.querySelector('.m-build-box__total-price');
//     this.form = this.querySelector('form');
    
//     this.attachEventListeners();
//     this.updateUI();
//   }

//   attachEventListeners() {
//     this.variantItems.forEach(item => {
//       const plusBtn = item.querySelector('.m-build-box__plus');
//       const minusBtn = item.querySelector('.m-build-box__minus');
      
//       if (plusBtn) {
//         plusBtn.addEventListener('click', (e) => {
//           e.stopPropagation();
//           this.addVariant(item);
//         });
//       }
      
//       if (minusBtn) {
//         minusBtn.addEventListener('click', (e) => {
//           e.stopPropagation();
//           this.removeVariant(item);
//         });
//       }
      
//       // Also allow clicking the card itself to add
//       item.addEventListener('click', () => this.addVariant(item));
//     });

//     if (this.clearBtn) {
//       this.clearBtn.addEventListener('click', () => this.clearSelections());
//     }

//     if (this.form) {
//       this.form.addEventListener('submit', (e) => this.handleSubmit(e));
//     }
//   }

//   addVariant(item) {
//     const variantId = item.dataset.variantId;
//     const totalSelected = this.selections.length;

//     if (totalSelected < this.boxSize) {
//       this.selections.push({
//         id: variantId,
//         title: item.dataset.variantTitle,
//         price: parseInt(item.dataset.variantPrice)
//       });
//       this.updateUI();
//     }
//   }

//   removeVariant(item) {
//     const variantId = item.dataset.variantId;
//     const index = this.selections.findIndex(s => s.id === variantId);
    
//     if (index !== -1) {
//       this.selections.splice(index, 1);
//       this.updateUI();
//     }
//   }

//   getVariantCount(variantId) {
//     return this.selections.filter(s => s.id === variantId).length;
//   }

//   calculateTotalPrice() {
//     return this.selections.reduce((total, selection) => {
//       return total + selection.price;
//     }, 0);
//   }

//   formatPrice(priceInCents) {
//     const currency = this.dataset.currency || '$';
//     const amount = (priceInCents / 100).toFixed(2);
//     return `${currency}${amount}`;
//   }

//   updateUI() {
//     const totalSelected = this.selections.length;
//     const progress = (totalSelected / this.boxSize) * 100;
//     const totalPrice = this.calculateTotalPrice();

//     // Update progress bar
//     if (this.progressFill) {
//       this.progressFill.style.width = `${progress}%`;
//     }

//     // Update progress text
//     if (this.progressText) {
//       this.progressText.textContent = `${totalSelected} / ${this.boxSize}`;
//     }

//     // Update price display
//     if (this.priceDisplay) {
//       if (totalSelected > 0) {
//         this.priceDisplay.textContent = this.formatPrice(totalPrice);
//         this.priceDisplay.style.display = 'block';
//       } else {
//         this.priceDisplay.style.display = 'none';
//       }
//     }

//     // Update variant items
//     this.variantItems.forEach(item => {
//       const variantId = item.dataset.variantId;
//       const count = this.getVariantCount(variantId);
//       const countBadge = item.querySelector('.m-build-box__variant-count');
//       const minusBtn = item.querySelector('.m-build-box__minus');

//       // Update selected state
//       if (count > 0) {
//         item.classList.add('selected');
//         if (countBadge) {
//           countBadge.textContent = count;
//           countBadge.style.display = 'flex';
//         }
//         if (minusBtn) {
//           minusBtn.style.display = 'flex';
//         }
//       } else {
//         item.classList.remove('selected');
//         if (countBadge) {
//           countBadge.style.display = 'none';
//         }
//         if (minusBtn) {
//           minusBtn.style.display = 'none';
//         }
//       }

//       // Disable if box is full
//       if (totalSelected >= this.boxSize) {
//         item.classList.add('disabled');
//       } else {
//         item.classList.remove('disabled');
//       }
//     });

//     // Update add to cart button
//     if (this.addToCartBtn) {
//       if (totalSelected === this.boxSize) {
//         this.addToCartBtn.disabled = false;
//         this.addToCartBtn.classList.remove('disabled');
//         // Update button text with price
//         const btnText = this.addToCartBtn.querySelector('span');
//         if (btnText) {
//           const baseText = this.dataset.buttonText || 'Add Box to Cart';
//           btnText.textContent = `${baseText} - ${this.formatPrice(totalPrice)}`;
//         }
//       } else {
//         this.addToCartBtn.disabled = true;
//         this.addToCartBtn.classList.add('disabled');
//         // Reset button text
//         const btnText = this.addToCartBtn.querySelector('span');
//         if (btnText) {
//           btnText.textContent = this.dataset.buttonText || 'Add Box to Cart';
//         }
//       }
//     }
//   }

//   clearSelections() {
//     this.selections = [];
//     this.updateUI();
//   }

//   async handleSubmit(e) {
//     e.preventDefault();
    
//     if (this.selections.length !== this.boxSize) {
//       return;
//     }

//     this.addToCartBtn.classList.add('loading');
    
//     try {
//       // Group selections by variant ID and count quantities
//       const variantGroups = {};
//       this.selections.forEach(selection => {
//         if (!variantGroups[selection.id]) {
//           variantGroups[selection.id] = {
//             id: selection.id,
//             title: selection.title,
//             price: selection.price,
//             quantity: 0
//           };
//         }
//         variantGroups[selection.id].quantity++;
//       });

//       // Create items array - each selected variant becomes a separate line item
//       const items = Object.values(variantGroups).map((variant, index) => {
//         return {
//           id: variant.id,
//           quantity: variant.quantity,
//           properties: {
//             '_Part of': 'Custom Build-a-Box',
//             '_Box Size': this.boxSize.toString(),
//             '_Item': `${index + 1} of ${Object.keys(variantGroups).length}`
//           }
//         };
//       });

//       // Add all items to cart in one request
//       const response = await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//         },
//         body: JSON.stringify({ items })
//       });

//       if (response.ok) {
//         const data = await response.json();
        
//         // Trigger cart update event
//         document.dispatchEvent(new CustomEvent('cart:updated'));
        
//         // Open cart drawer if available
//         if (window.theme && window.theme.cartDrawer) {
//           window.theme.cartDrawer.open();
//         }
        
//         // Show success message
//         const totalPrice = this.calculateTotalPrice();
//         this.showMessage(`Box added to cart! Total: ${this.formatPrice(totalPrice)}`, 'success');
        
//         // Clear selections
//         this.clearSelections();
//       } else {
//         throw new Error('Failed to add to cart');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       this.showMessage('Failed to add box to cart. Please try again.', 'error');
//     } finally {
//       this.addToCartBtn.classList.remove('loading');
//     }
//   }

//   showMessage(text, type) {
//     const messageEl = this.querySelector('.m-product-form-message');
//     if (messageEl) {
//       messageEl.textContent = text;
//       messageEl.className = `m-product-form-message ${type}`;
//       messageEl.style.display = 'block';
      
//       setTimeout(() => {
//         messageEl.style.display = 'none';
//       }, 3000);
//     }
//   }
// }

// customElements.define('build-box', BuildBox);


// Save this as 'build-box.js' in your assets folder

// Save this as 'build-box.js' in your assets folder

class BuildBox extends HTMLElement {
  constructor() {
    super();
    this.boxSize = parseInt(this.dataset.boxSize);
    this.selections = new Map();
    this.init();
  }

  init() {
    this.variantItems = this.querySelectorAll('.m-build-box__variant-item');
    this.progressFill = this.querySelector('.m-build-box__progress-fill');
    this.progressText = this.querySelector('.m-build-box__progress-text');
    this.totalPriceEl = this.querySelector('.m-build-box__total-price');
    this.addToCartBtn = this.querySelector('.m-build-box__add-to-cart');
    this.clearBtn = this.querySelector('.m-build-box__clear');
    this.form = this.querySelector('form');
    
    this.attachEventListeners();
    this.updateUI();
    this.updateVariantPrices(); // Initialize prices on load
  }

  attachEventListeners() {
    // Handle plus/minus buttons
    this.querySelectorAll('.m-build-box__plus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const item = btn.closest('.m-build-box__variant-item');
        this.handleIncrement(item);
      });
    });

    this.querySelectorAll('.m-build-box__minus').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.stopPropagation();
        const item = btn.closest('.m-build-box__variant-item');
        this.handleDecrement(item);
      });
    });

    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', () => this.clearSelections());
    }

    if (this.form) {
      this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }
  }

  handleIncrement(item) {
    const variantId = item.dataset.variantId;
    const currentCount = this.selections.get(variantId) || 0;
    const totalSelected = this.getTotalSelected();

    if (totalSelected < this.boxSize) {
      this.selections.set(variantId, currentCount + 1);
      this.updateUI();
    }
  }

  handleDecrement(item) {
    const variantId = item.dataset.variantId;
    const currentCount = this.selections.get(variantId) || 0;

    if (currentCount > 0) {
      const newCount = currentCount - 1;
      if (newCount === 0) {
        this.selections.delete(variantId);
      } else {
        this.selections.set(variantId, newCount);
      }
      this.updateUI();
    }
  }

  getTotalSelected() {
    let total = 0;
    this.selections.forEach(count => {
      total += count;
    });
    return total;
  }

  calculateTotalPrice() {
    let total = 0;
    this.selections.forEach((quantity, variantId) => {
      const item = this.querySelector(`[data-variant-id="${variantId}"]`);
      if (item) {
        const price = parseInt(item.dataset.variantPrice);
        total += (price * quantity) / this.boxSize;
      }
    });
    return total;
  }

  // Calculate price per item in the box
  calculatePricePerItem() {
    const totalPrice = this.calculateTotalPrice();
    const totalSelected = this.getTotalSelected();
    
    if (totalSelected === 0) {
      return 0;
    }
    
    // Price per item = total price / box size
    return Math.round(totalPrice / this.boxSize);
  }

  formatMoney(cents) {
    const currency = this.dataset.currency || '$';
    const amount = (cents / 100).toFixed(2);
    return `${currency}${amount}`;
  }

  // Update all variant prices to show per-item price
  updateVariantPrices() {
    const pricePerItem = this.calculatePricePerItem();
    
    this.variantItems.forEach(item => {
      const priceEl = item.querySelector('.m-build-box__variant-price');
      if (priceEl) {
        if (pricePerItem > 0) {
          priceEl.textContent = `${this.formatMoney(pricePerItem)} each`;
          priceEl.style.display = 'block';
        } else {
          priceEl.style.display = 'none';
        }
      }
    });
  }

  updateUI() {
    const totalSelected = this.getTotalSelected();
    const progress = (totalSelected / this.boxSize) * 100;

    // Update progress bar
    if (this.progressFill) {
      this.progressFill.style.width = `${progress}%`;
    }

    // Update progress text
    if (this.progressText) {
      this.progressText.textContent = `${totalSelected} / ${this.boxSize}`;
    }

    // Update total price
    if (this.totalPriceEl) {
      const totalPrice = this.calculateTotalPrice();
      this.totalPriceEl.textContent = this.formatMoney(totalPrice);
      this.totalPriceEl.style.display = totalSelected > 0 ? 'block' : 'none';
    }

    // Update variant prices (price per item)
    this.updateVariantPrices();

    // Update variant items
    this.variantItems.forEach(item => {
      const variantId = item.dataset.variantId;
      const count = this.selections.get(variantId) || 0;
      const countBadge = item.querySelector('.m-build-box__variant-count');
      const plusBtn = item.querySelector('.m-build-box__plus');
      const minusBtn = item.querySelector('.m-build-box__minus');

      // Update count display
      if (countBadge) {
        if (count > 0) {
          countBadge.textContent = count;
          countBadge.style.display = 'flex';
        } else {
          countBadge.style.display = 'none';
        }
      }

      // Update button states
      if (count > 0) {
        item.classList.add('selected');
        if (minusBtn) minusBtn.style.display = 'flex';
        if (plusBtn) plusBtn.style.display = totalSelected >= this.boxSize ? 'none' : 'flex';
      } else {
        item.classList.remove('selected');
        if (minusBtn) minusBtn.style.display = 'none';
        if (plusBtn) plusBtn.style.display = totalSelected >= this.boxSize ? 'none' : 'flex';
      }

      // Disable if box is full and not selected
      if (totalSelected >= this.boxSize && count === 0) {
        item.classList.add('disabled');
      } else {
        item.classList.remove('disabled');
      }
    });

    // Update add to cart button
    if (this.addToCartBtn) {
      const buttonText = this.dataset.buttonText || 'Add Box to Cart';
      const buttonTextEl = this.addToCartBtn.querySelector('span');
      
      if (totalSelected === this.boxSize) {
        this.addToCartBtn.disabled = false;
        this.addToCartBtn.classList.remove('disabled');
        const totalPrice = this.calculateTotalPrice();
        if (buttonTextEl) {
          buttonTextEl.textContent = `${buttonText} - ${this.formatMoney(totalPrice)}`;
        }
      } else {
        this.addToCartBtn.disabled = true;
        this.addToCartBtn.classList.add('disabled');
        if (buttonTextEl) {
          buttonTextEl.textContent = buttonText;
        }
      }
    }
  }

  clearSelections() {
    this.selections.clear();
    this.updateUI();
  }

  async handleSubmit(e) {
    e.preventDefault();
    
    if (this.getTotalSelected() !== this.boxSize) {
      return;
    }

    this.addToCartBtn.classList.add('loading');
    
    try {
      // Get first variant ID to use as base
      const firstVariantId = this.selections.keys().next().value;
      const totalPrice = this.calculateTotalPrice();
      const pricePerItem = this.calculatePricePerItem();
      
      // Build flavor list for display
      const flavorList = [];
      this.selections.forEach((quantity, variantId) => {
        const variantItem = this.querySelector(`[data-variant-id="${variantId}"]`);
        const variantTitle = variantItem.dataset.variantTitle;
        flavorList.push(`${variantTitle} x ${quantity}`);
      });

      // Create properties object with special _box_bundle flag
      const properties = {
        '_box_bundle': 'true',
        '_Box Type': 'Custom Build-a-Box',
        '_Box Size': this.boxSize.toString(),
        '_Bundle Price': this.formatMoney(totalPrice),
        '_Price Per Item': this.formatMoney(pricePerItem),
        'Flavors': flavorList.join('\n')
      };

      // Add to cart as a single line item
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: firstVariantId,
            quantity: 1,
            properties: properties
          }]
        })
      });

      if (response.ok) {
        const cartData = await response.json();
        
        // Trigger cart update event
        document.dispatchEvent(new CustomEvent('cart:updated'));
        
        // Try to open cart drawer
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        }
        
        // Refresh cart to show updated price
        if (window.location.pathname === '/cart') {
          window.location.reload();
        }
        
        // Show success message
        this.showMessage('Box added to cart successfully!', 'success');
        
        // Clear selections
        setTimeout(() => {
          this.clearSelections();
        }, 500);
      } else {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }
    } catch (error) {
      console.error('Error:', error);
      this.showMessage(error.message || 'Failed to add box to cart. Please try again.', 'error');
    } finally {
      this.addToCartBtn.classList.remove('loading');
    }
  }

  showMessage(text, type) {
    const messageEl = this.querySelector('.m-product-form-message');
    if (messageEl) {
      messageEl.textContent = text;
      messageEl.className = `m-product-form-message ${type}`;
      messageEl.style.display = 'block';
      
      setTimeout(() => {
        messageEl.style.display = 'none';
      }, 3000);
    }
  }
}

customElements.define('build-box', BuildBox);